import React from "react";
import { IgIconButton } from "@intelligems/ig-theme/IgIconButton";
import { Paperclip } from "lucide-react";
import { usePromptInputAttachments } from "@src/components/ai-elements/prompt-input-context/usePromptInputAttachments";

/**
 * Attachment control wired to `PromptInputProvider`'s `openFileDialog`. We render a
 * standalone button (not the dropdown-item variant) so it can sit directly
 * next to the model selector without a wrapping menu.
 *
 * Figma "Chat input" › attach: a 32px box, 6px radius, Icon/On-light/Default
 * glyph; hover fills Background/Interactive/Neutral/Hover and leaves the glyph
 * as it is.
 */
export const AddAttachmentsButton = ({
  disabled = false,
}: {
  disabled?: boolean;
}) => {
  const attachments = usePromptInputAttachments();
  return (
    <IgIconButton
      aria-label="Add attachment"
      disabled={disabled}
      onClick={() => attachments.openFileDialog()}
      sx={(theme) => ({
        borderRadius: "6px",
        color: theme.igIconColors.light,
        height: 32,
        width: 32,
        "&:hover": {
          backgroundColor: theme.igBackgroundColors.interactive.neutral.hover,
        },
      })}
    >
      <Paperclip size={16} />
    </IgIconButton>
  );
};
